var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleads(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-393 31 500 500",
    style: {
      enableBackground: "new -393 31 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.googleads0{fill:#3C8BD9;}\r\n\t.googleads1{fill:#FABC04;}\r\n\t.googleads2{fill:#34A852;}\r\n\t.googleads3{fill:#E1C025;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "googleads0",
    d: "M-201.3,156.2c3.5-9.3,8.4-17.8,15.6-24.7c28.8-28.1,76.4-21,96,14.3c14.7,26.8,30.3,52.9,45.4,79.4 c25.3,44,50.9,87.9,75.9,132c21,36.9-1.8,83.5-43.5,89.8c-25.6,3.8-49.5-7.9-62.8-30.9c-22.2-38.7-44.5-77.3-66.7-115.8 c-0.4-0.9-1-1.6-1.6-2.4c-2.4-1.9-3.4-4.7-4.9-7.2c-9.8-17.3-20-34.5-29.8-51.7c-6.3-11.2-12.9-22.2-19.3-33.4 c-5.7-10-8.4-20.9-8.1-32.3C-204.7,167.4-203.9,161.5-201.3,156.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "googleads1",
    d: "M-201.3,156.2c-1.3,5.3-2.5,10.6-2.8,16.2c-0.4,12.3,2.6,23.8,8.8,34.5c16.2,27.8,32.3,55.7,48.4,83.6 c1.5,2.5,2.6,5,4.1,7.3c-8.8,15.3-17.6,30.4-26.6,45.7c-12.3,21.3-24.7,42.8-37.2,64.1c-0.6,0-0.7-0.3-0.9-0.7 c-0.1-1.2,0.3-2.2,0.6-3.4c6-22,1-41.6-14.1-58.4c-9.3-10.1-21-15.9-34.5-17.8c-17.6-2.5-33.2,2.1-47.2,13.1 c-2.5,1.9-4.1,4.7-7.1,6.2c-0.6,0-0.9-0.3-1-0.7c7.1-12.2,14-24.4,21-36.6c29.1-50.6,58.2-101.1,87.5-151.6 C-202,157.3-201.6,156.8-201.3,156.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "googleads2",
    d: "M-310.2,346.5c2.8-2.5,5.4-5.1,8.4-7.5c35.7-28.2,89.4-7.8,97.2,36.9c1.9,10.7,0.9,21-2.4,31.3 c-0.1,0.9-0.3,1.6-0.6,2.5c-1.3,2.4-2.5,4.9-4,7.2c-13.1,21.6-32.3,32.3-57.6,30.7c-29-2.1-51.7-23.8-55.7-52.6 c-1.9-14,0.9-27,8.1-39.1c1.5-2.6,3.2-5,4.9-7.6C-311.2,347.6-311.5,346.5-310.2,346.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "googleads1",
    d: "M-310.2,346.5c-0.6,0.6-0.6,1.6-1.6,1.8c-0.1-1,0.4-1.6,1-2.4L-310.2,346.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "googleads3",
    d: "M-207.6,409.7c-0.6-1,0-1.8,0.6-2.5c0.1,0.1,0.4,0.4,0.6,0.6L-207.6,409.7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleads);
export default __webpack_public_path__ + "static/media/googleads.283e99229fef56ed4dca58406a2d3048.svg";
export { ForwardRef as ReactComponent };